const transition = {
  ease: 'easeInOut',
  duration: 0.4,
}

export const variantInner = {
  show: {
    transition,
    opacity: 1,
    display: 'flex',
  },
  hide: {
    transition,
    opacity: 0,
    display: 'none',
  },
}

export const variantGrid = {
  initial: {
    display: 'flex',
    y: 0,
  },
  show: {
    transition,
    y: 0,
  },
  hide: {
    transition,
    y: 20,
  },
}

export const variantRow = {
  initial: {
    display: 'flex',
    y: 0,
  },
  show: {
    y: 0,
    display: 'flex',
    transition: {
      ...transition,
      delay: 0.05,
    },
  },
  hide: {
    transition,
    y: 185,
    display: 'none',
  },
}

export const variantFullscreenTabs = {
  show: {
    transition,
    opacity: 1,
  },
  hide: {
    transition,
    opacity: 0,
  },
}

export const variantFullscreenTitle = {
  show: {
    transition,
    y: 0,
  },
  hide: {
    transition,
    y: -20,
  },
}

export const variantMinimizedTabs = {
  initial: {
    opacity: 1,
    y: 0,
  },
  show: {
    transition,
    y: 0,
  },
  hide: {
    y: 185,
    transition: {
      ...transition,
      delay: 0.05,
    },
  },
}
